import InnerComponent from '@Components/Inventory/ManageProducts/BOM/FormBOM';
import orgContainer from '@Components/AppContainer';

const CreateBOM = () => ((orgContainer(InnerComponent)));
export default CreateBOM;
